import React, { CSSProperties, useMemo } from 'react';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';
import GridSectionWrapper from 'src/components/GridSections/GridSectionWrapper/GridSectionWrapper';
import { cj, cm } from 'src/utils/classNames';

interface GridProps extends WithChildren, WithClassName {
	columns: string;
	rows: string;
}

const BaseGrid = ({ columns, rows, className, children }: GridProps) => {
	const style: CSSProperties = useMemo(
		() => ({
			gridTemplateColumns: `${columns}`,
			gridTemplateRows: `${rows}`,
		}),
		[columns, rows]
	);

	return (
		<div className={cm('grid gap-sm', className)} style={style}>
			{children}
		</div>
	);
};

interface CellProps extends WithChildren, WithClassName {
	style?: CSSProperties;
	skipWrapper?: boolean;
}

const Cell = ({ skipWrapper, className, children, style }: CellProps) => {
	if (skipWrapper) {
		return (
			<div className={className} style={style}>
				{children}
			</div>
		);
	}

	return (
		<GridSectionWrapper
			className={cj('thin-scroll overflow-auto', className)}
			style={style}
		>
			{children}
		</GridSectionWrapper>
	);
};

BaseGrid.Cell = Cell;
export default BaseGrid;
